import React from 'react';
import { Division } from '../../environments/EnvironmentTypes';
import { normalizeString } from 'services/utils/normalizeString';
import { useTranslation } from 'react-i18next';

interface SenderEmailsProps {
    divisions?: Division[];
    companyName?: string;
    emailDomainMethod?: 'default' | 'custom';
}

const SenderEmails: React.FC<SenderEmailsProps> = ({
    divisions,
    companyName,
    emailDomainMethod
}) => {
    const { t } = useTranslation();

    // Render the sender email rows
    const renderSenderEmailRows = () => {

        // Show explanation text for custom email domain method
        if (emailDomainMethod === 'custom') {
            return (
                <p className='explanation-text'>
                    {t('email.email_domain.custom_sender_domain_explanationText')}
                </p>
            );
        }
        
        // When the environment has multiple divisions, render their sender emails
        if (divisions && divisions.length > 0) {
            return (
                <div className='text-list'>
                    <p className='explanation-text'
                       style={{ marginBottom: '0.75rem' }}>
                        {t('email.email_domain.default_sender_domain_division_explanationText')}
                    </p>

                    {divisions.filter(division => division.is_active).map(division => {
                        return (
                            <div 
                                key={division.id}
                                className='list-item'            
                            >
                                <div className='list-item-label'>
                                    {division.name}
                                </div>
                                <div className='list-item-value'>
                                    {normalizeString(division.name || '')}@deliver.getcrafter.com
                                </div>
                            </div>
                        );
                    })}

                    <p className='explanation-text'>
                        {t('email.email_domain.sender_domain_description')}
                    </p>
                </div>
            );
        }

        // Render the default sender email
        return (
            <div className='col-70'>
                <p className='explanation-text'
                   style={{ marginBottom: '0.5rem' }}>
                    {t('email.email_domain.default_sender_domain_explanationText', { value: normalizeString(companyName || '') } )}
                </p>
                <p className='explanation-text'>
                    {t('email.email_domain.sender_domain_description')}
                </p>
            </div>
        );
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
            {renderSenderEmailRows()}
        </div>
    );
};

export default SenderEmails;